import { useState } from 'react';

import ScanProgressPreview from 'components/ScanProgressPreview';

export default function Scanning({ onClose }: { onClose: () => void }) {
  const [progress, setProgress] = useState<number>(0);

  return (
    <ScanProgressPreview
      progress={progress}
      setProgress={setProgress}
      onClose={onClose}
    />
  );
}
